// Angular imports
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prop',
    standalone: false
})
export class PropertyPipe implements PipeTransform {
    public transform(value: object, keyPath: string, defaultValue?: any): any {
        // Break up key path to keys
        const keys = keyPath.split('.');

        // Get property value
        const propValue = keys.reduce((container, key) => container?.[key], value);

        // Return value
        return propValue ?? defaultValue;
    }
}
